module.exports = __webpack_public_path__ + "static/media/type-campaign.29b5e76d.png";